/* Copyright (c) 2026 Goffy. All Rights Reserved. */

/*
 * Skin for react-datepicker on web. Colours come from the active skin: PlatformDatePicker.web.tsx
 * sets the --goffy-date-* variables on the .goffy-date-picker wrapper from appColors, so this file
 * holds layout and roles only. Every rule is scoped under the wrapper so it outranks the library
 * stylesheet, whose hover and selected rules carry :not([aria-disabled]) specificity.
 */

.goffy-date-picker {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  user-select: none;
}

.goffy-date-picker .react-datepicker {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 15px;
  background-color: var(--goffy-date-bg);
  border: 1px solid var(--goffy-date-border);
  border-radius: 10px;
  color: var(--goffy-date-text);
  overflow: hidden;
}

.goffy-date-picker .react-datepicker__month-container {
  float: none;
  flex: 1;
  min-width: 0;
}

.goffy-date-picker .react-datepicker__header {
  background-color: transparent;
  border-bottom: 1px solid var(--goffy-date-border);
  padding: 12px 0 6px;
}

.goffy-date-picker .react-datepicker__current-month,
.goffy-date-picker .react-datepicker-time__header {
  color: var(--goffy-date-text);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.goffy-date-picker .react-datepicker__navigation {
  top: 8px;
}

.goffy-date-picker .react-datepicker__navigation-icon::before {
  border-color: var(--goffy-date-label);
}

.goffy-date-picker .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
  border-color: var(--goffy-date-accent);
}

.goffy-date-picker .react-datepicker__month {
  margin: 6px 8px 8px;
}

.goffy-date-picker .react-datepicker__day-names,
.goffy-date-picker .react-datepicker__week {
  display: flex;
  justify-content: space-between;
  margin: 0 8px;
}

.goffy-date-picker .react-datepicker__month .react-datepicker__week {
  margin: 0;
}

.goffy-date-picker .react-datepicker__day-names {
  margin-bottom: 0;
}

.goffy-date-picker .react-datepicker__day-name,
.goffy-date-picker .react-datepicker__day {
  width: 2.2em;
  line-height: 2.2em;
  margin: 2px 0;
}

.goffy-date-picker .react-datepicker__day-name {
  color: var(--goffy-date-label);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.goffy-date-picker .react-datepicker__day {
  color: var(--goffy-date-text);
  border-radius: 8px;
}

.goffy-date-picker .react-datepicker__day--outside-month,
.goffy-date-picker .react-datepicker__day--disabled {
  color: var(--goffy-date-muted);
}

.goffy-date-picker .react-datepicker__day:not([aria-disabled='true']):hover {
  background-color: var(--goffy-date-hover);
  border-radius: 8px;
}

.goffy-date-picker .react-datepicker__day--today {
  box-shadow: inset 0 0 0 1px var(--goffy-date-accent);
}

.goffy-date-picker .react-datepicker__day--keyboard-selected {
  background-color: transparent;
  color: var(--goffy-date-text);
}

.goffy-date-picker .react-datepicker__day--selected,
.goffy-date-picker .react-datepicker__day--selected:not([aria-disabled='true']):hover,
.goffy-date-picker .react-datepicker__day--keyboard-selected:not([aria-disabled='true']):hover {
  background-color: var(--goffy-date-accent);
  color: var(--goffy-date-on-accent);
  font-weight: 700;
  border-radius: 8px;
}

.goffy-date-picker .react-datepicker__time-container {
  border-left: 1px solid var(--goffy-date-border);
}

.goffy-date-picker .react-datepicker__header--time {
  padding-top: 18px;
}

.goffy-date-picker .react-datepicker__time-container .react-datepicker__time {
  background: transparent;
}

.goffy-date-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  color: var(--goffy-date-text);
}

.goffy-date-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background-color: var(--goffy-date-hover);
}

.goffy-date-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected,
.goffy-date-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: var(--goffy-date-accent);
  color: var(--goffy-date-on-accent);
}
